// @flow
import React, { useEffect, useState, useCallback, useMemo } from 'react'
import * as DmsCommon from './../supports/dms-common';
import * as DmsService from './../supports/dms-service';
import { GlobalEvent, GlobalState } from './GlobalContext'
import MsgDialog from './MsgDialog';
import DocDListGridEdit from './DocDListGridEdit';
import SelMemberDialog from './SelMemberDialog';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import DialogTitle from '@mui/material/DialogTitle';
import PropTypes from 'prop-types';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import SaveIcon from '@mui/icons-material/Save';
import Box from '@mui/material/Box';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import PersonAddAlt1Icon from '@mui/icons-material/PersonAddAlt1';
import PersonRemoveIcon from '@mui/icons-material/PersonRemove';




export default function DocDListEditDialog(props) {

  const { sysID, open, onClose, docDetail, afterUpdate } = props;

  const distList = docDetail?.DList || [];


  // Get Global state and dispatcher
  const [gState, gStateDispatch] = React.useContext(GlobalState);

  const [gEvent, gEventDispatch] = React.useContext(GlobalEvent);

  const handleCloseClick = () => {
    onClose && onClose();
  }


  const [showLoading, setShowLoading] = useState(false);
  const [showError, setShowError] = useState(false);
  const [errMsg, setErrMsg] = useState("");

  // const [openAddDialog, setOpenAddDialog] = useState(false);
  const [anchorElAdd, setAnchorElAdd] = useState(null);
  const openAddDialog = Boolean(anchorElAdd);
  const handleAddClick = (event) => {
    setAnchorElAdd(event.currentTarget);
  };
  const handleCloseAddMenu = () => {
    setAnchorElAdd(null);
  };

  const [openAddUserDialog, setOpenAddUserDialog] = useState(false);
  const [allFolderUsers, setAllFolderUsers] = useState([]);
  // const [members, setMembers] = useState([]);
  const [groups, setGroups] = useState([]);

  const onCatchPromiseError = (e) => {
    gEventDispatch({
      showErr: true,
      err: e,
    });

  }

  const initGridData = () => {
    // console.log("initGridData distList", distList);
    const vData = distList.map(item => {
      return {
        "ActionReq": item.ActionReq,
        "DeptName": item.DeptName,
        "ToUserID": item.ToUserID,
        "ToUserName": item.ToUserName,
        "IsUser": true,
      }
    });

    // console.log("initGridData vData", vData);
    setGridData(vData);

    setModified(false);
  }


  useEffect(() => {
    // console.log("useEffect DocDListEditDialog(did mounted)");

    if (open === true) {
      initGridData();

      const xFunc = async () => {
        try {
          const [vAllFolderUsers, , vGroups] =
            await DmsService.getFolderAccessibleUsersPromise(gState.sessionID, sysID, docDetail.FolderID);
          setAllFolderUsers(vAllFolderUsers);
          // setMembers(vMembers);
          setGroups(vGroups);

        } catch (e) {
          onCatchPromiseError(e);
        }

      }
      xFunc();
    }

  }, [open]);



  const handleAddByUser = async () => {
    setAnchorElAdd(null);

    setOpenAddUserDialog(true);

  };


  const handleSelectAddUsers = (aUsers, aGroups) => {
    // console.log("aUsers", aUsers);
    // console.log("aGroups", aGroups);

    setOpenAddUserDialog(false);

    let vData = gridData.map(item => {
      return item
    });

    let vHasUpdate = false;

    aUsers.forEach(addUser => {
      const vFound = vData.find(f => f.ToUserID.toLowerCase() === addUser.UserID.toLowerCase());
      if (!vFound) {
        // console.log("addUser", addUser);
        const vNewItem = {
          "ActionReq": 0,
          "DeptName": addUser.Department,
          "ToUserID": addUser.UserID,
          "ToUserName": addUser.FullName,
          "IsUser": true,
        }

        vData.push(vNewItem);

        vHasUpdate = true;
      }
    });

    aGroups.forEach(addGroup => {
      const vFound = vData.find(f => f.ToUserID.toLowerCase() === addGroup.GroupID.toLowerCase());
      if (!vFound) {
        // console.log("addUser", addUser);
        const vNewItem = {
          "ActionReq": 0,
          "DeptName": "",
          "ToUserID": addGroup.GroupID,
          // "ToUserName": addGroup.GroupNameDisplay,
          "ToUserName": addGroup.Name,
          "IsUser": false,
        }

        vData.push(vNewItem);

        vHasUpdate = true;
      }
    });

    // console.log("vData", vData);
    setGridData(vData);

    if (vHasUpdate) {
      setModified(true);
      setSelectedRecs([]);
    }

  }

  const handleAddAllAuthUsers = async () => {
    setAnchorElAdd(null);

    setShowLoading(true);

    try {

      let vData = gridData.map(item => {
        return item
      });

      let vHasUpdate = false;

      // console.log("handleAddAllAuthUsers docDetail", docDetail);
      const vAll = (docDetail.Rights?.length == 0) || docDetail.Rights[0]?.UserOrGroupID == "*";


      if (vAll) {
        allFolderUsers.forEach(addUser => {
          const vFound = vData.find(f => f.ToUserID.toLowerCase() === addUser.UserID.toLowerCase());
          if (!vFound) {
            // console.log("addUser", addUser);
            const vNewItem = {
              "ActionReq": 0,
              "DeptName": addUser.Department,
              "ToUserID": addUser.UserID,
              "ToUserName": addUser.FullName,
              "IsUser": true,
            }

            vData.push(vNewItem);

            vHasUpdate = true;
          }
        });

        // groups.forEach(addGroup => {
        //   const vFound = vData.find(f => f.ToUserID.toLowerCase() === addGroup.GroupID.toLowerCase());
        //   if (!vFound) {
        //     const vNewItem = {
        //       "ActionReq": 0,
        //       "DeptName": "",
        //       "ToUserID": addGroup.GroupID,
        //       // "ToUserName": `[${addGroup.Name}]`,
        //       "ToUserName": addGroup.Name,
        //       "IsUser": false,
        //     }

        //     vData.push(vNewItem);

        //     vHasUpdate = true;
        //   }
        // });

      } else {
        docDetail.Rights.forEach(aRightRec => {
          const vFound = vData.find(f => f.ToUserID.toLowerCase() === aRightRec.UserOrGroupID.toLowerCase());
          if (!vFound) {

            const vNewItem = {
              "ActionReq": 0,
              "DeptName": aRightRec.Dept,
              "ToUserID": aRightRec.UserOrGroupID,
              "ToUserName": aRightRec.Name,
              "IsUser": aRightRec.IsUser,
            }

            vData.push(vNewItem);

            vHasUpdate = true;
          }
        })
      }

      if (vHasUpdate === true) {
        // console.log("vData", vData);
        setGridData(vData);

        if (vHasUpdate) {
          setModified(true);
          setSelectedRecs([]);
        }

      }

      setShowLoading(false);
    } catch (e) {
      setShowLoading(false);
      setErrMsg(e.errMsg || e.message);
      setShowError(true);
    };





  };

  const handleRemove = () => {
    // console.log("handleRemove selectedRecs", selectedRecs);

    const vData = gridData.filter(d => !selectedRecs.some(r => r.ToUserID === d.ToUserID));
    setGridData(vData);
    setSelectedRecs([]);

    setModified(true);
  }

  const [modified, setModified] = useState(false);

  const [selectedRecs, setSelectedRecs] = useState([]);
  const [gridData, setGridData] = useState([]);


  const handleActionChange = (aRecord, aNewValue) => {
    // console.log("handleActionChange", aCurIdx, aNewValue);

    setModified(true);

    const vNewGridData = gridData.map((d, idx) => {
      if (d.ToUserID == aRecord.ToUserID) {
        return {
          ...d,
          "ActionReq": aNewValue,
        }
      } else {
        return d;
      }
    });

    setGridData(vNewGridData);
  };

  const handleSelectionChange = (aRecords) => {


    setSelectedRecs(aRecords);

  }




  const handleSaveClick = () => {
    // console.log("handleSaveClick", gridData);

    const vDistList = gridData.map(d => {
      return {
        "UserID": d.ToUserID,
        "ActionReq": d.ActionReq,
      }
    })


    setShowLoading(true);
    DmsService.updateDocDListPromise(gState.sessionID, sysID, docDetail.DocID, vDistList)
      .then(() => {

        setShowLoading(false);
        setModified(false);

        afterUpdate && afterUpdate();
      })
      .catch((e) => {
        setShowLoading(false);

        console.log('Fail: ', e);

        onCatchPromiseError(e);

      })


  }

  return (
    <Dialog
      open={open}
      fullWidth={true}
      maxWidth={"xl"}
      aria-describedby="doc-dlist-edit-dialog-description"
    >
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={showLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <MsgDialog
        open={showError}
        title="Error"
        msgText={errMsg}
        onClose={() => setShowError(false)}
      />

      <SelMemberDialog
        open={openAddUserDialog}
        onClose={() => { setOpenAddUserDialog(false) }}
        members={allFolderUsers}
        groups={groups}
        onSelect={handleSelectAddUsers}
      />



      <DialogTitle id="alert-dialog-title">
        Distribution List
      </DialogTitle>
      <DialogContent>

        <Box sx={{ display: 'flex', flexDirection: 'column', height: "70vh" }} >
          <Box sx={{ py: 1, px: 1 }} >
            <Button
              id="add-button"
              aria-controls="add-menu"
              aria-haspopup="true"
              aria-expanded={openAddDialog ? 'true' : undefined}
              startIcon={<PersonAddAlt1Icon />}
              onClick={handleAddClick}
            >
              Add
            </Button>
            <Menu
              id="add-menu"
              anchorEl={anchorElAdd}
              open={openAddDialog}
              onClose={handleCloseAddMenu}
              MenuListProps={{
                'aria-labelledby': 'add-button',
              }}
            >
              <MenuItem onClick={handleAddByUser}>Users</MenuItem>
              <MenuItem onClick={handleAddAllAuthUsers}>All Authorized Users</MenuItem>
            </Menu>

            <Button startIcon={<PersonRemoveIcon />} disabled={selectedRecs.length == 0} onClick={handleRemove}>
              Remove
            </Button>

          </Box>

          <DocDListGridEdit
            gridData={gridData}
            onActionChange={handleActionChange}
            onSelectChange={handleSelectionChange}
          />

        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCloseClick}>Cancel</Button>
        <Button disabled={!modified} variant="contained" startIcon={<SaveIcon />} onClick={handleSaveClick} >
          Save
        </Button>
      </DialogActions>
    </Dialog>

  );
}

DocDListEditDialog.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  sysID: PropTypes.string,
  docDetail: PropTypes.object,
  afterUpdate: PropTypes.func,
};
